import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetBatchesActivities(ids: string[] | undefined) {
  return useQuery(queries.stocks.getBatchesActivitiesByIds(ids || []))
}
